<div #overlay class="overlay">
    <div class="modal-container">
        <ng-template appModalContent></ng-template>
    </div>
</div>